var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "padding": "20px"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.config.data ? _vm.config.data.name : ''))]), _vm._v(" "), (_vm.options.history) ? _c('div', {
    staticStyle: {
      "color": "#aaa",
      "font-size": "12px"
    }
  }, [_vm._v("当前正在浏览历史版本，创建于 " + _vm._s(_vm.options.history.version))]) : _vm._e(), _vm._v(" "), (_vm.config.tips) ? _c('div', {
    staticStyle: {
      "color": "#aaa",
      "font-size": "12px"
    }
  }, [_vm._v("* " + _vm._s(_vm.config.tips))]) : _vm._e()]), _vm._v(" "), (_vm.form) ? _c('Form', {
    ref: "form",
    staticStyle: {
      "border-top": "1px solid #f1f1f1"
    },
    attrs: {
      "model": _vm.form,
      "hide-required-mark": "",
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, _vm._l((_vm.config.form.cols), function(col, colIndex) {
    return _c('div', {
      key: colIndex,
      style: (("padding:20px;width:" + (col.width?(col.width + 40):300) + "px;word-break:break-all;box-sizing: border-box;" + (colIndex==_vm.config.form.cols.length-1?'':'border-right: 1px solid #f1f1f1;')))
    }, [(col.slot) ? _vm._t(col.slot) : _c('div', _vm._l((col.items), function(item, index) {
      return (item.vif ? item.vif(_vm.form) : !item.hide) ? _c('div', {
        key: index
      }, [(item.type == 'title') ? _c('div', {
        staticStyle: {
          "font-size": "18px",
          "margin-bottom": "20px"
        }
      }, [_vm._v(_vm._s(item.value))]) : _vm._e(), _vm._v(" "), (item.type == 'text') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('Input', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "placeholder": item.placeholder || '请输入',
          "maxlength": item.maxlength || 500,
          "show-word-limit": item['show-word-limit'] || false,
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, $$v)
          },
          expression: "form[item.key]"
        }
      }) : (item.render) ? _c('div', {
        style: (((item.style) + ";"))
      }, [_vm._v(_vm._s(item.render(item.key ? _vm.form[item.key] : (item.readonly ? _vm.config.current : _vm.form))))]) : (_vm.form[item.key]) ? _c('div', {
        style: (((item.style) + ";"))
      }, [_vm._v(_vm._s(_vm.form[item.key]))]) : _c('div', {
        staticStyle: {
          "color": "#aaa"
        }
      }, [_vm._v("无")])], 1) : (item.type == 'number') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "flex"
        }
      }, [(item.slot && item.slot.prepend) ? _c('div', [_vm._v(_vm._s(item.slot.prepend(_vm.form)))]) : _vm._e(), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('div', {
        staticStyle: {
          "position": "relative",
          "width": "100%"
        }
      }, [_c('Input', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "placeholder": item.placeholder || '请输入',
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false,
          "min": item.min,
          "max": item.max
        },
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, _vm._n($$v))
          },
          expression: "form[item.key]"
        }
      }, [(item.unit && item.unit.type == 'selector') ? _c('Select', {
        staticStyle: {
          "width": "70px"
        },
        attrs: {
          "slot": "append",
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        slot: "append",
        model: {
          value: (_vm.form[item.unit.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.unit.key, $$v)
          },
          expression: "form[item.unit.key]"
        }
      }, _vm._l((item.unit.selections), function(u, idx) {
        return _c('Option', {
          key: u.value || u,
          attrs: {
            "value": u.value || u
          }
        }, [_vm._v(_vm._s(u.name || u))])
      }), 1) : _vm._e()], 1)], 1) : _c('div', [_vm._v(_vm._s(_vm.form[item.key])), (item.unit) ? _c('span', [_vm._v(_vm._s((item.unit.selections.find(function (s) { return s == _vm.form[item.unit.key] || s.value == _vm.form[item.unit.key]; })) ? (item.unit.selections.find(function (s) { return s == _vm.form[item.unit.key] || s.value == _vm.form[item.unit.key]; }).name || item.unit.selections.find(function (s) { return s == _vm.form[item.unit.key] || s.value == _vm.form[item.unit.key]; })) : ''))]) : _vm._e()]), _vm._v(" "), (item.slot && item.slot.append) ? _c('div', [_vm._v(_vm._s(item.slot.append(_vm.form)))]) : _vm._e()])], 1) : (item.type == 'image') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('Uploader', {
        attrs: {
          "current": _vm.form[item.key],
          "editable": _vm.config.editable && !item.readonly && !(item.constant && _vm.config.current),
          "multi": item.multi,
          "max": item.max
        },
        on: {
          "confirm": function($event) {
            _vm.form[item.key] = $event
          }
        }
      })], 1) : (item.type == 'textarea') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('Input', {
        attrs: {
          "type": "textarea",
          "rows": item.rows || 4,
          "placeholder": item.placeholder || '请输入',
          "maxlength": item.maxlength || 500,
          "show-word-limit": item['show-word-limit'] || false,
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, $$v)
          },
          expression: "form[item.key]"
        }
      }) : _c('div', [_vm._v(_vm._s(_vm.form[item.key]))])], 1) : (item.type == 'label') ? _c('div', {
        style: (((item.style) + ";"))
      }, [_vm._v("\n                            " + _vm._s(item.render ? item.render(_vm.form) : item.value) + "\n                            "), _c('div', {
        staticStyle: {
          "height": "20px"
        }
      })]) : (item.type == 'switch') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), _c('i-switch', {
        attrs: {
          "disabled": !(_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current))
        },
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, $$v)
          },
          expression: "form[item.key]"
        }
      }, [_c('span', {
        attrs: {
          "slot": "open"
        },
        slot: "open"
      }, [_vm._v("是")]), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "close"
        },
        slot: "close"
      }, [_vm._v("否")])])], 1) : (item.type == 'daterange') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('DatePicker', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "clearable": item.clearable || false,
          "value": _vm.form[item.key],
          "format": item.format || 'yyyy-MM-dd',
          "type": "daterange",
          "placement": "bottom-end",
          "placeholder": "请选择",
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            return _vm.daterangeChanged(item, $event)
          }
        }
      }) : (_vm.form[item.key] && _vm.form[item.key][0]) ? _c('div', [_vm._v(_vm._s(_vm.form[item.key][0]) + " - " + _vm._s(_vm.form[item.key][1]))]) : _c('div', {
        staticStyle: {
          "color": "#aaa"
        }
      }, [_vm._v("无")])], 1) : (item.type == 'time') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('TimePicker', {
        staticStyle: {
          "width": "112px"
        },
        attrs: {
          "format": "HH:mm",
          "value": _vm.form[item.key],
          "placeholder": "请选择",
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            _vm.form[item.key] = $event
          }
        }
      }) : (_vm.form[item.key]) ? _c('div', [_vm._v(_vm._s(_vm.form[item.key]))]) : _c('div', {
        staticStyle: {
          "color": "#aaa"
        }
      }, [_vm._v("无")])], 1) : (item.type == 'date') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('DatePicker', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "format": item.format || 'yyyy-MM-dd',
          "value": _vm.form[item.key],
          "placeholder": "请选择",
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            _vm.form[item.key] = $event
          }
        }
      }) : (_vm.form[item.key]) ? _c('div', [_vm._v(_vm._s(_vm.form[item.key]))]) : _c('div', {
        staticStyle: {
          "color": "#aaa"
        }
      }, [_vm._v("无")])], 1) : (item.type == 'datetime') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('DatePicker', {
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "format": item.format || 'yyyy-MM-dd HH:mm:ss',
          "type": "datetime",
          "value": _vm.form[item.key],
          "placeholder": "请选择",
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            return _vm.datePickerChanged(_vm.form, item, $event)
          }
        }
      }) : (_vm.form[item.key]) ? _c('div', [_vm._v(_vm._s(_vm.form[item.key]))]) : _c('div', {
        staticStyle: {
          "color": "#aaa"
        }
      }, [_vm._v("无")])], 1) : (item.type == 'custom') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('CustomData', {
        attrs: {
          "current": _vm.form[item.key],
          "editable": _vm.config.editable && !item.readonly && !(item.constant && _vm.config.current),
          "multi": item.multi,
          "moveable": item.moveable,
          "max": item.max,
          "datatype": item.datatype,
          "unimode": item.unimode,
          "query": item.query,
          "fields": item.fields,
          "columns": item.columns,
          "useMendianSelector": item.useMendianSelector
        },
        on: {
          "confirm": function($event) {
            _vm.form[item.key] = $event
          }
        }
      })], 1) : (item.type == 'biaodanziduan') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('FormItemEditor', {
        attrs: {
          "current": _vm.form[item.key],
          "editable": _vm.config.editable && !item.readonly && !(item.constant && _vm.config.current),
          "max": item.max
        },
        on: {
          "confirm": function($event) {
            _vm.form[item.key] = $event
          }
        }
      })], 1) : (item.type == 'checkbox') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('CheckboxGroup', {
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, $$v)
          },
          expression: "form[item.key]"
        }
      }, _vm._l((item.loader ? item.loader(_vm.form) : item.selections), function(selection) {
        return _c('Checkbox', {
          key: selection,
          attrs: {
            "label": selection
          }
        }, [_vm._v(_vm._s(selection))])
      }), 1)], 1) : (item.type == 'list') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('TextList', {
        attrs: {
          "options": item,
          "current": _vm.form[item.key]
        }
      })], 1) : (item.type == 'radio') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('RadioGroup', {
        attrs: {
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            item.change ? item.change({
              form: _vm.form
            }) : null
          }
        },
        model: {
          value: (_vm.form[item.key]),
          callback: function($$v) {
            _vm.$set(_vm.form, item.key, $$v)
          },
          expression: "form[item.key]"
        }
      }, _vm._l((item.loader ? item.loader(_vm.form) : item.selections), function(r, i) {
        return _c('Radio', {
          key: i,
          attrs: {
            "label": r.value,
            "disabled": r.disabled
          }
        }, [_c('span', [_vm._v(_vm._s(r.name))])])
      }), 1) : _c('div', [_c('span', [_vm._v(_vm._s(item.selections.find(function (o) { return o.value == _vm.form[item.key]; }) ? item.selections.find(function (o) { return o.value == _vm.form[item.key]; }).name : ''))])])], 1) : (item.type == 'selector') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (item.multi) ? _c('div', [(_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('div', [_c('Select', {
        attrs: {
          "value": _vm.form[item.key].map(function (i) {
            return item.render(i)
          }),
          "filterable": item.filterable || false,
          "clearable": item.clearable || false,
          "multiple": "",
          "placeholder": item.placeholder || '请选择',
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            return _vm.selectorChanged(item, $event)
          }
        }
      }, _vm._l((item.loader ? item.loader(_vm.form) : item.selections), function(selection, selectionindex) {
        return _c('Option', {
          key: selectionindex,
          attrs: {
            "value": item.render(selection)
          }
        }, [_vm._v(_vm._s(item.render(selection)))])
      }), 1)], 1) : _c('div', [_vm._v(_vm._s(item.render(_vm.form[item.key])))])]) : _c('div', [(_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('div', [_c('Select', {
        attrs: {
          "value": item.render(_vm.form[item.key]),
          "filterable": item.filterable || false,
          "clearable": item.clearable || false,
          "placeholder": item.placeholder || '请选择',
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "on-change": function($event) {
            return _vm.selectorChanged(item, $event)
          }
        }
      }, _vm._l((item.loader ? item.loader(_vm.form) : item.selections), function(selection, selectionindex) {
        return _c('Option', {
          key: selectionindex,
          staticClass: "nowrap",
          style: (("" + (item.width?('width:'+item.width+'px'):''))),
          attrs: {
            "value": item.render(selection)
          }
        }, [_vm._v(_vm._s(item.render(selection)))])
      }), 1)], 1) : _c('div', [_vm._v(_vm._s(item.render(_vm.form[item.key])))])])], 1) : (item.type == 'location') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (_vm.form[item.key]) ? _c('div', {
        staticClass: "center hover",
        staticStyle: {
          "color": "#20bf64",
          "font-weight": "bold",
          "height": "80px",
          "border-radius": "6px",
          "text-align": "center",
          "background": "url('http://cdn.igyl.com/vendor-statics/mapbg.png')"
        },
        on: {
          "click": function($event) {
            return _vm.locationSelector.show(item.key)
          }
        }
      }, [_c('div', [_vm._v(_vm._s(_vm.form[item.key].name))])]) : _c('div', {
        staticClass: "center hover",
        staticStyle: {
          "color": "#20bf64",
          "font-weight": "bold",
          "height": "80px",
          "border-radius": "6px",
          "text-align": "center",
          "background": "url('http://cdn.igyl.com/vendor-statics/mapbg.png')"
        },
        on: {
          "click": function($event) {
            return _vm.locationSelector.show(item.key)
          }
        }
      }, [_c('div', [_vm._v("在地图中选择")])])], 1) : (item.type == 'jigou' || item.type == 'gonghuojigou') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (!_vm.form[item.key]) ? _c('div', {
        staticStyle: {
          "font-size": "12px",
          "margin-left": "4px"
        }
      }, [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), (_vm.config.editable && !item.readonly && !(item.constant && _vm.config.current)) ? _c('BaseSelect', {
        attrs: {
          "value": _vm.form[item.key],
          "autoload": "",
          "multiple": item.multi,
          "type": item.type,
          "width": "100%",
          "parameter": item.query,
          "placeholder": item.placeholder,
          "disabled": item.disabledif ? item.disabledif(_vm.form) : false
        },
        on: {
          "change": function($event) {
            return _vm.jigouChanged(item, $event)
          }
        }
      }) : _c('BaseSelect', {
        attrs: {
          "readonly": "",
          "value": _vm.form[item.key],
          "multiple": item.multi,
          "type": item.type
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.type == 'slot') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), (item.slot) ? _c('div', [(item.slot) ? _vm._t(item.slot) : _vm._e()], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.type == 'a') ? _c('FormItem', {
        attrs: {
          "prop": item.key,
          "label": item.name
        }
      }, [_c('FormItemLabel', {
        attrs: {
          "slot": "label",
          "item": item
        },
        slot: "label"
      }), _vm._v(" "), _c('div', [_c('a', {
        on: {
          "click": function($event) {
            return item.onclick({
              form: _vm.form,
              item: item
            })
          }
        }
      }, [_vm._v(_vm._s(item.render ? item.render(item.key ? _vm.form[item.key] : _vm.form) : _vm.form[item.key]))])])], 1) : _vm._e(), _vm._v(" "), (item.tip) ? _c('div', [_c('div', {
        staticStyle: {
          "font-size": "12px",
          "color": "#aaa",
          "margin-top": "-20px",
          "margin-bottom": "20px"
        }
      }, [_vm._v(_vm._s(item.tip))])]) : _vm._e(), _vm._v(" "), (col.spacer) ? _c('div', [_c('div', {
        style: (("height: " + (col.spacer) + "px;"))
      })]) : _vm._e()], 1) : _vm._e()
    }), 0)], 2)
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "border-top": "1px solid #f1f1f1"
    }
  }, [(_vm.config.current && _vm.config.caozuojiluOn) ? _c('Caozuojilu', {
    attrs: {
      "items": _vm.caozuojilus
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "jcsb"
  }, [(_vm.config.mode != 'page') ? _c('div', [(_vm.config.current && _vm.config.editable && _vm.config.delete && _vm.deleteable) ? _c('div', {
    staticClass: "hover",
    staticStyle: {
      "color": "red"
    },
    on: {
      "click": _vm.toDelete
    }
  }, [_vm._v("删除")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), (_vm.config.editable) ? _c('Button', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.toSave({})
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), (_vm.config.submitable) ? _c('Button', {
    staticStyle: {
      "width": "100px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.toSave({
          tijiao: true
        })
      }
    }
  }, [_vm._v("保存并提交")]) : _vm._e(), _vm._v(" "), _vm._t("menus")], 2)])], 1), _vm._v(" "), _c('Modal', {
    staticClass: "nopadding",
    attrs: {
      "footer-hide": "",
      "width": 500
    },
    model: {
      value: (_vm.locationSelector.display),
      callback: function($$v) {
        _vm.$set(_vm.locationSelector, "display", $$v)
      },
      expression: "locationSelector.display"
    }
  }, [(_vm.locationSelector.display) ? _c('LocationSelector', {
    attrs: {
      "current": _vm.locationSelector.current
    },
    on: {
      "cancel": function($event) {
        _vm.locationSelector.display = false;
      },
      "locationSelected": _vm.locationSelector.confirm
    }
  }) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acc0252a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DefaultForm.vue
// module id = Xl+7
// module chunks = 138